import React, { useState, useEffect } from "react";
import { Table, Card, Button, Spinner, Alert } from "react-bootstrap";
import { FaPrint, FaSync } from "react-icons/fa";
import api from "../../axiosConfig";

export default function RaportProfitabilitateService() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchData = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/comenzi/interna/rapoarte/profitabilitate");
      setData(res.data);
    } catch (err) {
      console.error(err);
      setError("Eroare la încărcarea raportului.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Profitabilitate pe Deviz (Service Auto)</h4>
        <div>
          <Button variant="outline-secondary" className="me-2" onClick={fetchData} disabled={loading}>
            <FaSync className="me-1" /> Actualizează
          </Button>
          <Button variant="primary" onClick={() => window.print()} className="d-print-none">
            <FaPrint className="me-1" /> Printează
          </Button>
        </div>
      </div>
      <Card className="shadow-sm border-0">
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {loading ? (
            <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
          ) : (
            <div className="table-responsive">
              <Table bordered hover striped className="align-middle text-center">
                <thead className="table-light">
                  <tr>
                    <th>Deviz / Data</th>
                    <th>Auto</th>
                    <th>Client</th>
                    <th>Încasat Piese</th>
                    <th>Încasat Manoperă</th>
                    <th>Cost Piese (FIFO)</th>
                    <th className="text-success fw-bold">Profit Brut</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, idx) => (
                    <tr key={idx}>
                      <td>#{row.bxnumar_comanda} <br/><small className="text-muted">{row.bxdata}</small></td>
                      <td className="fw-bold">{row.bxnr_auto}</td>
                      <td className="text-start">{row.client}</td>
                      <td className="text-end text-primary">{Number(row.total_incasat_piese).toFixed(2)} Lei</td>
                      <td className="text-end text-primary">{Number(row.total_incasat_manopera).toFixed(2)} Lei</td>
                      <td className="text-end text-danger">{Number(row.cost_achizitie_piese).toFixed(2)} Lei</td>
                      <td className={`text-end fw-bold ${row.profit_brut >= 0 ? 'text-success' : 'text-danger'}`}>
                        {Number(row.profit_brut).toFixed(2)} Lei
                      </td>
                    </tr>
                  ))}
                  {data.length === 0 && <tr><td colSpan="7" className="text-center text-muted py-4">Nu există devize închise.</td></tr>}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
      <style>{`
        @media print {
          .d-print-none, .navbar, .sidebar { display: none !important; }
          body { background: white; padding: 0; margin: 0; }
          .container-fluid { padding: 0; }
          .card { border: none !important; box-shadow: none !important; }
        }
      `}</style>
    </div>
  );
}
